import { render, staticRenderFns } from "./DataTableWrapper.vue?vue&type=template&id=37d7db0d&"
import script from "./DataTableWrapper.vue?vue&type=script&lang=js&"
export * from "./DataTableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d7db0d')) {
      api.createRecord('37d7db0d', component.options)
    } else {
      api.reload('37d7db0d', component.options)
    }
    module.hot.accept("./DataTableWrapper.vue?vue&type=template&id=37d7db0d&", function () {
      api.rerender('37d7db0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-table-wrapper/DataTableWrapper.vue"
export default component.exports